import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/area`


export const AreaGet = async (token, areaId) => {

  const response = await axios.get(`${API_URL}/${areaId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};


export const GetAreas = async (token, page, limit) => {
  const response = await axios.post(`${API_URL}/areas?page=${page}&limit=${limit}`, {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const CreateArea = async (token, {name, description, is_active}) => {
  const body = { name, description, is_active}
  const response = await axios.post(`${API_URL}/`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};


export const UpdateArea = async ({token, id, name, description, is_active}) => {
try {
  const body = { name, description, is_active}
  const response = await axios.patch(`${API_URL}/${id}`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
}
catch(error){
  return error.response
}

}

export const DeleteArea = async (token, id) => {
try {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
}
catch(error){
  console.log(error.response)
  return error.response
}

}